import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { constructSeries } from './functions'
import { styled, Typography } from '@mui/material'
import { array } from 'prop-types'

const StyleDiv = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '1.3rem',
  justifyContent: 'center',
  height: '100%',
  color: theme.palette.primary.main
}))

const Donutchart = ({ postagens = [] }) => {
  const [series, setSeries] = useState([])
  const [labels, setLabels] = useState([])

  useEffect(() => {
    init(postagens)
  }, [postagens])

  const init = async () => {
    const { labels, series } = await constructSeries(postagens, 'donut')
    setSeries(series)
    setLabels(labels)
  }

  const options = {
    labels,
    legend: {
      position: 'bottom',
      color: 'red',
      fontSize: '15px'
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: false
          }
        }
      }
    }
  }

  return (
    <div
      style={{
        height: '86%'
      }}
    >
      {series.length > 0 && (
        <Chart
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            marginTop: '6%'
          }}
          type="donut"
          options={options}
          series={series}
          height="95%"
        />
      )}
      {series.length === 0 && <StyleDiv>(Não há dados para exibir)</StyleDiv>}
    </div>
  )
}

Donutchart.propTypes = {
  postagens: array
}
export default Donutchart
